/**
 * Owner "login as client" support sessions. The backend adds this claim to
 * the custom token; it stays on every ID token of that sign-in session.
 */
export const SUPPORT_SESSION_EXPIRES_AT_CLAIM = "supportSessionExpiresAt";

/** How often an open tab checks whether the support session has ended. */
export const SUPPORT_SESSION_CHECK_INTERVAL_MS = 15 * 1000;

export const getSupportSessionExpiresAt = (claims) => {
  const value = claims?.[SUPPORT_SESSION_EXPIRES_AT_CLAIM];
  if (value === undefined || value === null) {
    return null;
  }

  const expiresAt = Number(value);
  // A malformed value is treated as already ended (the backend does the same).
  return Number.isFinite(expiresAt) ? expiresAt : 0;
};

export const isSupportSessionExpired = (expiresAt, now = Date.now()) =>
  expiresAt !== null && expiresAt !== undefined && now >= expiresAt;

/**
 * Same signal as the support-session banner: the claim is present on the
 * signed-in user for the whole login-as session. A missing claim is a normal
 * sign-in. isHidden on an adsUsers child is not this check.
 */
export const isSupportSessionUser = (user) =>
  (user?.supportSessionExpiresAt ?? null) !== null;

/**
 * Skip agencies/{agencyID}/lastLogin and the user's lastLogins while this
 * sign-in is a support session, a privileged login, or an explicit skip.
 */
export const shouldSkipAccountLastLoginWrite = ({
  skipLastLogin = false,
  isPrivilegedLogin = false,
  user = null,
} = {}) =>
  skipLastLogin === true ||
  isPrivilegedLogin === true ||
  isSupportSessionUser(user);
